import '@fontsource/outfit/300.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
import '@fontsource/sora/400.css';
import '@fontsource/sora/500.css';
import '@fontsource/sora/600.css';
import '@fontsource/sora/700.css';
import './index.css';
import './styles/brand-theme.css';

import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { loadConfig } from './app/config.tsx';
import { AppProviders } from './app/providers.tsx';
import { createAppRouter } from './router.tsx';

const AUTH_CALLBACK_PATH = '/auth/callback';

// Auth0 redirects the browser to `/auth/callback` (the path registered on the Auth0 application).
// Hand the code and state to the API, which sets the session cookies and redirects into the app.
if (window.location.pathname === AUTH_CALLBACK_PATH) {
  window.location.replace(`/api${AUTH_CALLBACK_PATH}${window.location.search}`);
} else {
  const container = document.getElementById('root');
  if (!container) throw new Error('Missing #root element');
  const root = createRoot(container);

  // Runtime config is a static file overwritten per deployment; load it before first render.
  const config = await loadConfig();
  const router = createAppRouter();

  root.render(
    <StrictMode>
      <AppProviders config={config}>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
}
